// extracted by mini-css-extract-plugin
export default {"head":"styles_head__3jOPn","tableRow":"styles_tableRow__1KVa2"};